export default __webpack_public_path__ + "static/media/ApprovalPageHeaderBg.166c7214.png";